module.exports = "<md-content layout=\"row\">\r\n    <span flex></span>\r\n    <md-button class=\"image-button\" aria-label=\"Edit\" ng-click=\"vm.privateonedit()\">\r\n        <md-icon class=\"material-icons\">mode_edit</md-icon>\r\n        <span class=\"image-button-label\">Edit</span>\r\n    </md-button>\r\n    <md-button class=\"image-button\" aria-label=\"Delete\" ng-click=\"vm.privateondelete()\">\r\n        <md-icon class=\"material-icons\">delete</md-icon>\r\n        <span class=\"image-button-label\">Delete</span>\r\n    </md-button>\r\n</md-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/creweditdeletebuttons.html
// module id = 1195
// module chunks = 1